export default __webpack_public_path__ + "static/media/slider3-8.2cba3235.jpg";